/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IWixxGameData, IWixxServerData} from "./data/IWixxServerData";

export class WixxServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseStackedReelFourRespinTriggered(rawData:IWixxServerData):boolean {
        return rawData.stackedReelFourRespinTriggered;
    }

    public parseStackedReelFourRespinActive(rawData:IWixxServerData):boolean {
        return rawData.stackedReelFourRespinActive;
    }

    public parseSymbolToWildRespinActive(rawData:IWixxServerData):boolean {
        return rawData.symbolToWildRespinActive;
    }

    public parseMultiplierRespinActive(rawData:IWixxServerData):boolean {
        return rawData.multiplierRespinActive;
    }

    public parseHighlightWilds(rawData:IWixxGameData):boolean[][] {
        return rawData.wildHighlight;
    }

    public parseExcitementPositions(rawData:IWixxGameData):boolean[][] {
        return rawData.excitementPositions;
    }
}